<ng-template #template>
  <ng-content></ng-content>
</ng-template>
